import { Button } from "@freightsimple/ui-core/Controls/Button";
import { PlusIcon } from "@phosphor-icons/react/Plus";

interface LocationsAddLocationButtonProps {
  onClick: () => void;
}

/**
 * The large "Add New Location" call to action used by every empty state on the
 * address book. Large because in an empty state it is the only thing to do —
 * the header carries the ordinary-sized version of the same action.
 */
export function LocationsAddLocationButton(
  props: LocationsAddLocationButtonProps,
) {
  return (
    <Button primary size="large" icon={PlusIcon} onClick={props.onClick}>
      Add New Location
    </Button>
  );
}
